import { OnboardingEntityDraft } from "../../OnboardingDataContext";

export type EntityTreeNode = {
  entity: OnboardingEntityDraft;
  children: EntityTreeNode[];
};

export const buildEntityTree = (
  entities: OnboardingEntityDraft[]
): EntityTreeNode[] => {
  const idSet = new Set(
    entities.map((entity) => entity.entityId).filter(Boolean)
  );

  const parentIdOf = (entity: OnboardingEntityDraft): string | undefined => {
    const { relationKind, relatedEntityId } = entity;
    if (
      relationKind === "subsidiary" &&
      relatedEntityId &&
      idSet.has(relatedEntityId)
    ) {
      return relatedEntityId;
    }
    return undefined;
  };

  const childrenOf = new Map<string, OnboardingEntityDraft[]>();
  entities.forEach((entity) => {
    const parentId = parentIdOf(entity);
    if (!parentId) return;
    const list = childrenOf.get(parentId) ?? [];
    list.push(entity);
    childrenOf.set(parentId, list);
  });

  const visited = new Set<string>();
  const keyOf = (entity: OnboardingEntityDraft): string =>
    entity.entityId ?? entity.localId;

  const buildNode = (entity: OnboardingEntityDraft): EntityTreeNode => {
    visited.add(keyOf(entity));
    const kids = (entity.entityId ? childrenOf.get(entity.entityId) ?? [] : [])
      .filter((kid) => !visited.has(keyOf(kid)))
      .map(buildNode);
    return { entity, children: kids };
  };

  return entities.filter((entity) => !parentIdOf(entity)).map(buildNode);
};
